import React, { useEffect } from 'react';
import '../pages/About.css';
import abountus from "../assets/img/AboutImages/about1.png";
import about from "../assets/img/AboutUsImg.png";
import visionicon from '../assets/img/AboutImages/visionIcon.png';
import Header from "../components/Header"//header
import Footer from "../components/Footer"//footer
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import plusicon from '../assets/img/product_img/plusicon.png';
import { Helmet } from "react-helmet-async";
import WhatsappButton from '../components/WhatsappButton';

const About = () => {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <div className='about'>
      <Helmet>
        <title>Indoor playground and soft play manufacturer in Jordan</title>
        <meta name="soft play" content="Discover GEM, the ultimate indoor 
playground! We provide top-quality fun with
 safe, innovative designs. Trusted playground
 equipment suppliers for endless adventure!" />
      </Helmet>
      <Header />
      <div className="about-container">
        <div className="about-content">
          <h1 style={{ paddingLeft: "2%" }} data-aos="fade-right" data-aos-duration="2500">Unveiling The   <br>
          </br><span className="highlight">GEM Experience</span></h1>
          <p style={{ padding: "2%", marginTop: "9%" }} data-aos="fade-right" data-aos-duration="2500">
          Global Entertainment Manufacturer  blend innovation, creativity, and technology to craft world-class entertainment experiences, pushing boundaries with immersive attractions and digital solutions to inspire, transform, and redefine the future of entertainment worldwide.
          </p>
        </div>
        <div className="about-image" >
          <div className="about-image1" data-aos="zoom-in-up" data-aos-duration="2500">
            <img src={about} alt="playground equipment catalog" />
          </div>
        </div>
      </div>

      {/* code for aboutus */}
      <div className="aboutus-container">
        <div className="aboutus-content">
          {/* Left Section - Image */}
          <div className="aboutus-image"  >
            <img style={{ width: "80%", marginTop: "75px" }}
              src={abountus} // Replace with your image path
              alt="indoor commercial playground"

            />
          </div>
            <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
          <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="commercial indoor playground equipment"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>

          {/* Right Section - Text Content */}
          <div className="aboutus-text" data-aos="fade-up"
            data-aos-anchor-placement="center-bottom" data-aos-duration="2500" >
            {/* <Link to="/getquotations">
              <button className="hover-button">Get Quotation</button>
            </Link> */}
            <h1 className='aboutus-h1'>About Us</h1>
            <p className="aboutus-paragraph">
            Global Entertainment Manufacturer is a premier manufacturer and supplier in the location-based entertainment industry. Providing quality, safety and innovative solutions to the trampoline park and indoor playground market, GEM has the skill to bring any soft play area to life – from design concepts to finished projects.
            </p>
            <p className="aboutus-paragraph">
            Our engineering, design, and art departments are second to none, they will create the right project to suit your needs, thrill and excite your guests with the best entertainment experience. Whether it is an <a href='https://gemplay.com.jo/#/Playground'>indoor playgrounds</a> or a trampoline park, we customize your project with colors and artwork that will make it a unique attraction.
            </p>
            <p className="aboutus-paragraph">
            With focus on operational excellence and customer satisfaction, GEM is dedicated to providing high quality and durable playgrounds that stand the test of time. All of our products are made with the finest materials and constructed with the utmost attention to detail, ensuring that they are safe and well built.
            </p>
          </div>
        </div>

      </div>

      {/* code for vision */}

      <div className="vision-container" >
        <div className="card" data-aos="fade-down-right" data-aos-duration="2500">
          <div className="card-header">
            <img src={visionicon} alt="commercial indoor playground equipment" className="card-icon" />
            <h2>Our Mission</h2>
          </div>
          <p className="card-text1">
          Safety And Trustworthiness Are The Ground For All That We Do. We Are Committed To Delivering High Quality Products And Services To Our Customers So They Keep Their Business Earning Year After Year With GEM.
          </p>
        </div>
        <div className="card" data-aos="fade-down-left" data-aos-duration="2500">
          <div className="card-header">
            <img src={visionicon} alt="playground equipment manufacturers" className="card-icon" />
            <h2>Our Vision</h2>
          </div>
          <p className="card-text1">
          We Want To Revolutionize The Soft Play Industry By Creating The Most Imaginative, Interactive And Safest Playground Environments In The World, And Be Your Company Of Choice When It Comes To A Full-Service Manufacturing And Design Facility.

          </p>
        </div>
      </div>

      {/* code for services */}

      <div className="service-container" >

        <div className="firstSection" >
          {/* First Section */}
          <div className="service-header" data-aos="zoom-out-up" data-aos-duration="2500">
            <h2 >What We Serve</h2>
            <h1>We Help You To Find <br /> The Right Choice</h1>
            <p>
              Exploring immersive gaming experiences, or diving into cutting-edge
              virtual reality technology, we're here to guide you every step of the
              way. Trust GEM to help you find the right choice and elevate your
              entertainment journey to new heights.
            </p>
          </div>

          {/* Second Section */}
          <div style={{ display: "flex", flexDirection: "column", width: "90%", gap: "5%", textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "5%" }}>

              <div className="service-box red"  >
                Quality, Safety And Innovative Solutions To The Trampoline Park And
                Indoor Playground
              </div>
              <div className="service-box blue"  >
                The Right Project To Suit Your Needs, Thrill And Excite Your Guests
                With The Best Entertainment Experience
              </div>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }} >
              <div className="service-box yellow"  >
                Operational Excellence And Customer Satisfaction
              </div>
            </div>
          </div>
        </div>


        <div>
          {/* <button className="service-button">Get Quotation</button> */}
        </div>

      </div>
      <Footer />

    </div>
  );
};



export default About;
